import { ApolloProvider } from '@apollo/client'
import { FC, PropsWithChildren, ReactNode } from 'react'
import { Provider as ReduxProvider } from 'react-redux'

import useStore from 'src/hooks/useStore'
import { useApollo } from 'src/lib/apollo'
import { YdAppProps } from 'src/types/next'
import { useInitSocket } from './hooks/use-init-socket'

interface DALProps extends PropsWithChildren {
  children: ReactNode
  pageProps: YdAppProps
}

export const DataAccessLayer: FC<DALProps> = ({
  children,
  pageProps
}: DALProps) => {
  // With pageProps we have an access to all redux and apollo data
  // we can split it among multiple Context Providers based on domains
  // User, Board, Network, etc.
  const store = useStore(pageProps)
  const apolloClient = useApollo(pageProps)
  useInitSocket()

  return (
    <ReduxProvider store={store} noopCheck="never">
      <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
    </ReduxProvider>
  )
}
